const KEY_PREFIX = 'quote-clone-draft:';

type ClonedQuoteDraftMeta = {
  clonedAt?: string;
};

function safeKey(policyId: string) {
  return `${KEY_PREFIX}${policyId}`;
}

function getStorage() {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function parseStoredMeta(raw: string | null): ClonedQuoteDraftMeta | null {
  if (!raw) return null;
  if (raw === '1') return {};

  try {
    const parsed = JSON.parse(raw) as ClonedQuoteDraftMeta;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function markClonedQuoteAsDraft(policyId: string, clonedAt?: string) {
  const id = (policyId || '').trim();
  if (!id) return;

  try {
    const payload: ClonedQuoteDraftMeta = {
      clonedAt: clonedAt || new Date().toISOString(),
    };
    getStorage()?.setItem(safeKey(id), JSON.stringify(payload));
  } catch {
    //
  }
}

export function clearClonedQuoteDraftMark(policyId: string) {
  const id = (policyId || '').trim();
  if (!id) return;

  try {
    getStorage()?.removeItem(safeKey(id));
    sessionStorage.removeItem(safeKey(id));
  } catch {
    //
  }
}

export function getClonedQuoteDraftMeta(policyId: string | undefined) {
  const id = (policyId || '').trim();
  if (!id) return null;

  try {
    const key = safeKey(id);
    const localMeta = parseStoredMeta(getStorage()?.getItem(key) ?? null);
    if (localMeta) return localMeta;

    const legacySessionMeta = parseStoredMeta(sessionStorage.getItem(key));
    if (legacySessionMeta) {
      markClonedQuoteAsDraft(id, legacySessionMeta.clonedAt);
      sessionStorage.removeItem(key);
      return legacySessionMeta;
    }

    return null;
  } catch {
    return null;
  }
}

export function isClonedQuoteMarkedAsDraft(policyId: string | undefined) {
  return !!getClonedQuoteDraftMeta(policyId);
}
